module.exports = __webpack_public_path__ + "static/D365-human-resource-management_2-575ce96f66efe104e8cad6960e3e73e7.png";